import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

export default function disabledStyle({ disabled = false }: ButtonStyleProps) {
  if (disabled) {
    return css`
      opacity: 0.3;
      cursor: not-allowed !important;

      &:hover, &:focus, &:active {
        opacity: 0.3;
      }
    `;
  }
}
